import { useMemo } from 'react'
import { useDealDecisionOptions } from '@/hooks/use-deal-leads'

export function useCriterionLabels(): Map<string, string> {
  const options = useDealDecisionOptions()

  return useMemo(
    () =>
      new Map(
        (options.data?.reasons ?? []).map((reason) => [reason.id, reason.label])
      ),
    [options.data]
  )
}
